import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { GlobalDialogsProvider } from './contexts/GlobalDialogsContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Clients from './pages/Clients';
import Policies from './pages/Policies';
import Tasks from './pages/Tasks';
import Renewals from './pages/Renewals';
import Commissions from './pages/Commissions';
import Campaigns from './pages/Campaigns';
import Quotations from './pages/Quotations';
import ClientDetail from './pages/ClientDetail';
import LeadForms from './pages/LeadForms';
import PublicForm from './pages/PublicForm';
import PublicAgent from './pages/PublicAgent';
import SessionExpiryWarning from './components/SessionExpiryWarning';
import Reports from './pages/Reports';
import LostLeads from './pages/LostLeads';
import PolicyDetail from './pages/PolicyDetail';
import Announcements from './pages/Announcements';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import Billing from './pages/Billing';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Admin from './pages/Admin';
import Claims from './pages/Claims';
import ClaimDetail from './pages/ClaimDetail';
import './App.css';

const guarded = (El) => (
  <ProtectedRoute>
    <GlobalDialogsProvider>
      <Layout>{El}</Layout>
    </GlobalDialogsProvider>
  </ProtectedRoute>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SessionExpiryWarning />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/f/:slug" element={<PublicForm />} />
          <Route path="/agent/:slug" element={<PublicAgent />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={guarded(<Dashboard />)} />
          <Route path="/leads" element={guarded(<Leads />)} />
          <Route path="/clients" element={guarded(<Clients />)} />
          <Route path="/clients/:clientId" element={guarded(<ClientDetail />)} />
          <Route path="/leads/forms" element={guarded(<LeadForms />)} />
          <Route path="/policies" element={guarded(<Policies />)} />
          <Route path="/policies/:policyId" element={guarded(<PolicyDetail />)} />
          <Route path="/renewals" element={guarded(<Renewals />)} />
          <Route path="/tasks" element={guarded(<Tasks />)} />
          <Route path="/commissions" element={guarded(<Commissions />)} />
          <Route path="/campaigns" element={guarded(<Campaigns />)} />
          <Route path="/quotations" element={guarded(<Quotations />)} />
          <Route path="/reports" element={guarded(<Reports />)} />
          <Route path="/lost-leads" element={guarded(<LostLeads />)} />
          <Route path="/announcements" element={guarded(<Announcements />)} />
          <Route path="/claims" element={guarded(<Claims />)} />
          <Route path="/claims/:claimId" element={guarded(<ClaimDetail />)} />
          {/* Removed routes (services, etc.) redirect to dashboard instead of blank */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
          <Route path="/notifications" element={guarded(<Notifications />)} />
          <Route path="/settings" element={guarded(<Settings />)} />
          <Route path="/billing" element={guarded(<Billing />)} />
          <Route path="/admin" element={guarded(<Admin />)} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
